import appStore, { type AppConfig } from '@studio/core/appStore/index';
import { matchPath } from '@studio/router';

function createMatchObject(app: AppConfig) {
  return {
    name: app.title,
    route: app.route.pattern,
  };
}

/**
 * @deprecated Use useAppConfig instead.
 */
export function getAppNameFromPath(pathname: string): string {
  return (
    appStore
      .unsafe_getState()
      .values()
      .map(createMatchObject)
      .find(appName => matchPath(pathname, appName.route) !== null)?.name ??
    'Portal'
  );
}
